import {HttpContextToken} from "@angular/common/http";

export const USE_ACTIVE_LOCATION =
  new HttpContextToken<boolean>(() => false);

